import {
    getAxios,
} from './axios'

import {addAuthTokenData} from './member';

export function getMemberPhotos(params = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/photos/',
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberPhotos.js